export function GlobalErrorBoundary({ error }: { error: unknown }) {
  const errorMessage = error instanceof Error ? error.message : String(error);

  return (
    <p className="p-4 text-xs">{`There was a problem loading the app. Please reload this page. If the problem persists, reach out to us, support@vooma.ai Error: ${errorMessage}`}</p>
  );
}
